import {
  activityDefinitions, activityTypes, isActivityType, normalizeActivityQuantity, type ActivityType,
} from './activities';

export function renderActivityForm(): string {
  return `
    <form id="activity-form" class="activity-form" novalidate>
      <label class="field">
        <span data-activity-amount-label>Amount</span>
        <input id="activity-amount" type="number" min="1" step="1" value="10" required />
      </label>
      <label class="field">
        <span>Activity</span>
        <select id="activity-type">${activityTypes.map((type) => `<option value="${type}">${type}</option>`).join('')}</select>
      </label>
      <p id="activity-duration-note" class="card-copy" hidden>1 point per 5 seconds. Time rounds down to five-second increments.</p>
      <div class="activity-presets" hidden>
        <button class="btn btn-secondary" type="button" data-activity-seconds="30">30s</button>
        <button class="btn btn-secondary" type="button" data-activity-seconds="60">1m</button>
      </div>
      <button class="btn" type="submit">Submit Activity</button>
    </form>
  `;
}

export function mountActivityForm(form: HTMLFormElement): void {
  const amount = form.querySelector<HTMLInputElement>('#activity-amount')!;
  const select = form.querySelector<HTMLSelectElement>('#activity-type')!;
  const label = form.querySelector<HTMLElement>('[data-activity-amount-label]')!;
  const note = form.querySelector<HTMLElement>('#activity-duration-note')!;
  const presets = form.querySelector<HTMLElement>('.activity-presets')!;
  let previousUnit = activityDefinitions.Pushups.unit;

  const update = () => {
    if (!isActivityType(select.value)) return;
    const definition = activityDefinitions[select.value];
    if (previousUnit !== definition.unit) amount.value = String(definition.defaultQty);
    previousUnit = definition.unit;
    amount.min = String(definition.min);
    amount.step = String(definition.step);
    const timed = definition.unit === 'seconds';
    label.textContent = timed ? 'Seconds' : 'Amount';
    note.hidden = !timed;
    presets.hidden = !timed;
    if (timed) amount.setAttribute('aria-describedby', note.id);
    else amount.removeAttribute('aria-describedby');
  };

  select.addEventListener('change', update);
  amount.addEventListener('blur', () => {
    if (!isActivityType(select.value) || activityDefinitions[select.value].unit !== 'seconds') return;
    const qty = normalizeActivityQuantity(select.value, amount.valueAsNumber);
    if (qty !== null) amount.value = String(qty);
  });
  form.querySelectorAll<HTMLButtonElement>('[data-activity-seconds]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!isActivityType(select.value) || activityDefinitions[select.value].unit !== 'seconds') return;
      amount.value = button.dataset.activitySeconds!;
      amount.focus();
    });
  });
  update();
}

export function readActivityFormSubmission(form: HTMLFormElement): { type: ActivityType; qty: number } | null {
  const amount = form.querySelector<HTMLInputElement>('#activity-amount')!;
  const select = form.querySelector<HTMLSelectElement>('#activity-type')!;
  if (!isActivityType(select.value)) return null;
  const qty = normalizeActivityQuantity(select.value, amount.valueAsNumber);
  if (qty !== null) amount.value = String(qty);
  // Native step validation runs after rounding, including Enter-key submissions.
  if (!form.reportValidity() || qty === null) return null;
  return { type: select.value, qty };
}
